function getWhatsAppUrl(text = "") {
  return new URL(
    `https://us-central1-auto-clupp.cloudfunctions.net/cluppAPI/v1/contact?text=${text}`
  ).href;
}

export default getWhatsAppUrl;
